<template>
<div class="row align-items-center pt-2 pb-2 border-top" >
<div class="col-sm-6">
        <span class>{{ labelText }}</span>
      </div>
      <div class="col-sm-6">
         <dropdownlist
         class="w-50"
      :data-items="dataSource"
      :default-value="fieldName"
      :value="value"
      @change="$emit('input', $event.target.value)"
    ></dropdownlist>
      </div>
      </div>
  <!-- <div class="col-3 mb-3">
    <label>{{ fieldName }}</label>
    <dropdownlist
      class="w-100"
      :data-items="dataSource"
      :default-value="fieldName"
      :value="value"
      @change="$emit('input', $event.target.value)"
    ></dropdownlist>
  </div> -->
</template>
<script>
export default {
  name: "DropdownList",
  props: ["multi", "dataSource", "name","labelText" ,"fieldName", "value"],
};
</script>
